import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Header";
import {
  CONTACTS,
  FOOTER_NAV,
  SOCIAL_LINKS,
  LEGAL_LINKS,
  MAPS_URL,
  TEL_HREF,
  MAILTO,
  whatsappHref,
} from "../mock";

export default function Footer() {
  return (
    <footer className="pb-10 pt-16">
      <div className="mx-auto max-w-[1360px] px-6 lg:px-10">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <Logo />
            <p className="mt-5 max-w-[240px] text-[0.92rem] leading-relaxed text-[#6f6f68]">
              Compra e vendi auto usate verificate. Prima la conosciamo noi, poi
              la proponiamo a te.
            </p>
          </div>

          <div>
            <p className="label-mono mb-5">Sede</p>
            <p className="text-[0.95rem] text-[#4a4a45]">{CONTACTS.address}</p>
            <p className="mt-2 text-[0.95rem] text-[#4a4a45]">{CONTACTS.hours}</p>
            <a
              href={MAPS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 inline-block text-[0.95rem] underline underline-offset-4 transition-opacity hover:opacity-60"
            >
              Indicazioni stradali
            </a>
          </div>

          <div>
            <p className="label-mono mb-5">Contatti</p>
            <a href={TEL_HREF} className="block text-[0.95rem] text-[#4a4a45] hover:text-[var(--cm-ink)]">
              Ufficio: {CONTACTS.ufficio}
            </a>
            <a
              href={whatsappHref("Ciao, vi scrivo dal sito Carmaps.")}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 block text-[0.95rem] text-[#4a4a45] hover:text-[var(--cm-ink)]"
            >
              WhatsApp: {CONTACTS.whatsapp}
            </a>
            <a href={MAILTO} className="mt-2 block text-[0.95rem] text-[#4a4a45] hover:text-[var(--cm-ink)]">
              {CONTACTS.email}
            </a>
          </div>

          <div>
            <p className="label-mono mb-5">Naviga</p>
            <div className="flex flex-col gap-2">
              {FOOTER_NAV.map((n) => (
                <Link
                  key={n.label}
                  to={n.to}
                  className="text-[0.95rem] text-[#4a4a45] transition-colors hover:text-[var(--cm-ink)]"
                >
                  {n.label}
                </Link>
              ))}
            </div>
            <div className="mt-5 flex flex-wrap gap-2">
              {SOCIAL_LINKS.map((s) => (
                <a
                  key={s.label}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="rounded-full border border-[var(--cm-line)] px-3.5 py-1.5 text-[0.8rem] transition-colors hover:border-[var(--cm-ink)]"
                >
                  {s.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col justify-between gap-4 border-t border-[var(--cm-line)] pt-6 text-[0.8rem] text-[#8a8a82] md:flex-row md:items-center">
          <p>
            © 2026 Carmaps · Collegno (TO) · P. IVA {CONTACTS.piva} · RUI{" "}
            {CONTACTS.rui} · www.carmaps.it è l'unico sito ufficiale
          </p>
          <div className="flex gap-6">
            {LEGAL_LINKS.map((l) => (
              <Link
                key={l.label}
                to={l.url}
                data-testid={`footer-legal-${l.label.toLowerCase()}`}
                className="transition-colors hover:text-[var(--cm-ink)]"
              >
                {l.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
